import React, {useState} from "react";
import {supabase} from "../../supabase";
import {Box, Button, Card, CardContent, TextField, Typography, useTheme,} from "@mui/material";

import {useTranslation} from "react-i18next";
import AuthLogo from "./AuthLogo";
import {Link} from "react-router-dom";

export default function () {

    const theme = useTheme();
    const {t} = useTranslation();
    const [email, setEmail] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);

    async function forget() {
        setLoading(true);
        const {error} = await supabase.auth.resetPasswordForEmail(
            email
        );
        if (!error) {
            setLoading(false);
            alert(t("auth.checkMailToReset"));
        }
        if (error) {
            setLoading(false);
            alert(error.message);
        }
    }

    return <Card sx={{
        minWidth: 300,
        textAlign: "center",
        opacity: 0.95
    }}>
        <CardContent>
            <AuthLogo/>

            <Typography
                variant="h3"
                sx={{
                    alignSelf: "center",
                }}
            >
                {t("auth.forget")}
            </Typography>
            <Typography>{t("std.email")}</Typography>
            <TextField
                sx={{width: "100%"}}
                placeholder={t("auth.emailPlaceholder")}
                value={email}
                autoCapitalize="none"
                autoComplete="email"
                variant={"outlined"}
                onChange={(e) => setEmail(e.target.value)}
            />
            <Box>

                <Button
                    onClick={() => {
                        forget();
                    }}
                    variant={"contained"}
                    sx={{
                        width: "100%",
                        marginTop: "1em",
                    }}
                    disabled={loading}
                >{loading ? t("std.loading") : t("auth.sendEmail")}</Button>
            </Box>

            <Box
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: 15,
                    justifyContent: "center",
                }}
            >
                <Typography variant="body2">{t("auth.haveAccount")}</Typography>
                <Link to={"/Login"}>
                    <Typography
                        variant="body2"
                        style={{
                            fontWeight: "bold",
                            marginLeft: 5,
                        }}
                    >
                        {t("auth.loginHere")}
                    </Typography>
                </Link>
            </Box>
        </CardContent>
    </Card>;
}
